import { Pipe, PipeTransform } from '@angular/core';
import { Nursery } from 'app/models/Nursery';


@Pipe({
  name: 'orderByMembership'
})

export class OrderByMembershipPipe implements PipeTransform {
  transform(nurseries: Nursery[]): Nursery[] {
    if (!nurseries) return [];

    return nurseries.sort((a: Nursery, b: Nursery): number => {
      if (a.is_member > b.is_member) {
        return -1;
      }
      if (a.is_member < b.is_member) {
        return 1;
      }
      if (a.distanceToMe < b.distanceToMe) {
        return -11;
      }
      if (a.distanceToMe > b.distanceToMe) {
        return 1;
      }
      if (a.name < b.name) {
        return 1;
      }
      if (a.name > b.name) {
        return -1;
      }
      return 0;
    });
  }
}
